export const setCookie = (key: string, value: string) => {
  document.cookie = `${key}=${value}; domain=${process.env.REACT_APP_DOMAIN}; path=/; max-age=31536000`;
};

export const getCookie = (key: string) => {
  return (
    document.cookie
      .split("; ")
      .find((row) => row.startsWith(key + "="))
      ?.split("=")[1] || null
  );
};
